import React, { useCallback, useEffect } from 'react'

import CheckBox from '../../../icones/check-circle.svg'
import Fechar from '../../../icones/icone-fechar-branco.svg'
import Info from '../../../icones/infoAmarelo.svg'
import { useGlobal } from '../../../stores/useGlobal'

import * as S from './styles'

const DEFAULT_NOTIFICATION = {
  show: false,
  type: 'default',
  title: '',
  message: '',
  autoHide: 3000
}

function Notification() {
  const { mostrarNotificacao, setMostrarNotificacao } = useGlobal()

  const { type, title, message, autoHide } = mostrarNotificacao

  const handleClose = useCallback(
    () => setMostrarNotificacao(DEFAULT_NOTIFICATION),
    [setMostrarNotificacao]
  )

  useEffect(() => {
    if (autoHide && mostrarNotificacao.show) {
      const timer = setTimeout(() => handleClose(), autoHide || 3000)
      return () => clearTimeout(timer)
    }
  }, [autoHide, mostrarNotificacao, handleClose])

  const types = {
    default: {},
    warning: {
      icon: <S.Img type={type} alt="info" src={Info} />
    },
    success: {
      icon: <S.Img type={type} alt="success" src={CheckBox} />
    },
    error: {
      icon: (
        <S.CloseWrapper>
          <S.Img alt="close" src={Fechar} />
        </S.CloseWrapper>
      )
    },
    loading: { color: '#33CC99', loading: true, withCloseButton: false }
  }

  const notificationProps = types[type]

  if (!mostrarNotificacao.show) return null

  return (
    <S.NotificationWrapper>
      <S.Notification
        onClose={handleClose}
        title={title}
        {...notificationProps}
      >
        {message}
      </S.Notification>
    </S.NotificationWrapper>
  )
}

export default React.memo(Notification)
